// component
import SvgColor from '../../../components/svg-color';

// ----------------------------------------------------------------------
const icon = (name) => <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />;

const navConfig = [
  {
    title: 'dashboard',
    path: '/admin/app',
    icon: icon('ic_analytics'),
  },
  {
    title: 'users',
    path: '/admin/user',
    icon: icon('ic_user'),
  },
  {
    title: 'master game',
    path: '/admin/master-game',
    icon: icon('ic_user'),
  },
  {
    title: 'Declare Result',
    path: '/admin/result-game-declared',
    icon: icon('ic_user'),
  },
  {
    title: 'Pending Result',
    path: '/admin/pending-result',
    icon: icon('ic_user'),
  },

  {
    title: 'Game Types',
    path: '/admin/game-types',
    icon: icon('ic_user'),
  },
  {
    title: 'Game Rates',
    path: '/admin/game-rates',
    icon: icon('ic_user'),
  },

  {
    title: 'Bids',
    path: '/admin/game-bids',
    icon: icon('ic_user'),
  },

  {
    title: 'Winners',
    path: '/admin/winners-list',
    icon: icon('ic_user'),
  },

  {
    title: 'Withdrawal',
    path: '/admin/withdrawal-requests',
    icon: icon('ic_user'),
  },

  {
    title: 'Wallet Requests',
    path: '/admin/wallet-requests',
    icon: icon('ic_user'),
  },

  {
    title: 'Wallet',
    path: '/admin/wallet-history',
    icon: icon('ic_user'),
  },

  {
    title: 'Settings',
    path: '/admin/setting',
    icon: icon('ic_user'),
  },

  // {
  //   title: 'product',
  //   path: '/admin/products',
  //   icon: icon('ic_cart'),
  // },
  // {
  //   title: 'blog',
  //   path: '/admin/blog',
  //   icon: icon('ic_blog'),
  // },
  // {
  //   title: 'login',
  //   path: '/login',
  //   icon: icon('ic_lock'),
  // },
  // {
  //   title: 'Not found',
  //   path: '/404',
  //   icon: icon('ic_disabled'),
  // },
];

export default navConfig;
